import Vue from 'vue';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { MUTATIONS, _STAFF_STORE } from '../values/staff.values';
import { StaffService } from '../services/staff.service';
import { WEEK_DAYS } from '@/values/general.values';

export const STAFF_STORE = _STAFF_STORE;

@Module({ namespaced: true })
export class StaffStore extends VuexModule {

  /* State */
  public orgUsers: any = []; 
  public filterOrgUsers: any = [];
  public unregUsers: any = [];
  public filterUnregUsers: any = [];

  /* Mutations */
  @Mutation
  public setOrganizationUsersM(users){
    let content = users.content
    let page = users.number
    this.orgUsers = [...this.orgUsers, {page, content}]
  }

  @Mutation
  public setFilterOrganizationUsersM(users){
    let content = users.content
    let page = users.number
    this.filterOrgUsers = [...this.filterOrgUsers, {page, content}]
  }

  @Mutation
  public setUnregisteredUsersM(users){
    let content = users.content
    let page = users.number
    this.unregUsers = [...this.unregUsers, {page, content}]
  }

  @Mutation
  public setFilterUnregisteredUsersM(users){
    let content = users.content
    let page = users.number
    this.filterUnregUsers = [...this.filterUnregUsers, {page, content}]
  }

  @Mutation
  public resetUsersM() {
    this.orgUsers = []
    this.filterOrgUsers = []
  }

  /* Actions */
  @Action({rawError:true})
  public getUsersByOrganizationA({orgId,page=0,pageSize=10}:{orgId:number,page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      StaffService.getUsersByOrganizationId(orgId,page,pageSize).then((res:any) => {
        this.context.commit(MUTATIONS.SET_ORGANIZATION_USERS_M, res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
    });
  }

  @Action({rawError:true})
  public searchUsersOrganizationA({orgId,keyword='',userTypes='',page=0,pageSize=10}:
      {orgId:number,keyword:string,userTypes:string,page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      StaffService.searchUsersInOrganization(orgId,keyword,userTypes,page,pageSize).then((res:any) => {
        this.context.commit(MUTATIONS.SET_FILTER_ORGANIZATION_USERS_M, res);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public getUnregisteredUsersA({page=0,pageSize=10}:{page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      StaffService.getUnregisteredUsers(page,pageSize).then((res:any) => {
        this.context.commit(MUTATIONS.SET_UNREGISTERED_USERS_M, res);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public searchUnregisteredUsersA({keyword='', userType='',page=0,pageSize=10}:
      {keyword:string,userTypes:string,userType:string,page:number,pageSize:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      StaffService.searchUnregisteredUsers(keyword, userType, page, pageSize).then((res:any) => {
        this.context.commit(MUTATIONS.SET_FILTER_UNREGISTERED_USERS_M, res);
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  @Action({rawError:true})
  public removeUserFromOrganizationA({id}:{id:number}): Promise<any>{
    return new Promise((resolve,reject) => {
      StaffService.removeUserFromOrganization(id).then((res:any) => {
        this.context.commit(MUTATIONS.RESET_USERS_M)
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.orgUsers = []; 
    this.filterOrgUsers = [];
    this.unregUsers = [];
    this.filterUnregUsers = [];
  }

}
